export enum TargetAudience {
	CHILDREN_0_6 = 'CHILDREN_0_6',
	CHILDREN_6_12 = 'CHILDREN_6_12',
	ADOLESCENTS_12_18 = 'ADOLESCENTS_12_18',
	ADULT_18_22 = 'ADULT_18_22',
	ADULT_22_65 = 'ADULT_22_65',
	SENIOR_65 = 'SENIOR_65',
	FAMILY = 'FAMILY',
}

export const TARGET_AUDIENCES = [
	TargetAudience.CHILDREN_0_6,
	TargetAudience.CHILDREN_6_12,
	TargetAudience.ADOLESCENTS_12_18,
	TargetAudience.ADULT_18_22,
	TargetAudience.ADULT_22_65,
	TargetAudience.SENIOR_65,
	TargetAudience.FAMILY,
];
